import { useQuery } from "@tanstack/react-query";
import { useTraccarSession } from "./useTraccarSession";
import { fetchResellerProfile, AuthenticationError } from "@/lib/reseller-api";

export function useResellerAccess() {
  const { user, isLoading } = useTraccarSession();

  // Primary check: Traccar admin or unlimited device/user limits
  const isPrimaryReseller = !!user && (
    user.administrator ||
    (user.deviceLimit === -1 && user.userLimit === -1)
  );

  // Secondary check: user may be a reseller admin (linked via reseller_admin_users)
  const { data: profile, isLoading: profileLoading } = useQuery({
    queryKey: ["reseller-profile"],
    queryFn: fetchResellerProfile,
    enabled: !!user && !isPrimaryReseller,
    retry: (failureCount, error) => {
      if (error instanceof AuthenticationError) return false;
      return failureCount < 2;
    },
    staleTime: 1 * 60 * 1000,
  });

  const isReseller = isPrimaryReseller || (!!profile && profile.traccar_user_id === user?.id);

  return {
    isReseller,
    isCheckingAccess: isLoading || (!isPrimaryReseller && !!user && profileLoading),
  };
}
